export function reducerConfigInscricao(state: any, action: any) {
  if (typeof action === 'function') return action(state)

  if (action.type === 'ALTERA_ETAPAS') return { ...state, etapas: action.etapas }
  if (action.type === 'MERGE') return { ...state, ...action.payload }
  if (action.type === 'SET') return action.payload

  return state
}